<div class="modal-header">
    <h5 class="modal-title">Import Parent Accounts</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="dismiss()"></button>
</div>
<dirty-tracking [forms]="[importForm]"></dirty-tracking>
<form #importForm="ngForm" [ngClass]="{'was-validated': submitAttempt}">
    <div class="modal-body">
        <div class="row gx-2">
            <div class="col-md mb-3">
                <label for="sourceEnvironment" class="form-label">Source Environment<sup class="text-danger">*</sup></label>
                <select class="form-control form-control-lg" id="sourceEnvironment" name="sourceEnvironment" placeholder="Source" required [(ngModel)]="connString" (ngModelChange)="getParents()">
                    <option disabled [value]="null">Select...</option>
                    <option *ngFor="let e of environments" [value]="e.connString">{{e.connName}}</option>
                </select>
                <div class="invalid-feedback">
                    <i class="fas fa-exclamation-circle"></i> This field is required.
                </div>
            </div>
        </div>
        <div class="row gx-2 mb-2" style="max-height:50vh;overflow-y:auto;" *ngIf="connString">
            <div class="form-check mb-3" *ngFor="let p of parents">
                <input class="form-check-input" type="checkbox" value="" [attr.id]="'doImport' + p.parentId" name="doImport" [(ngModel)]="p.doImport" (ngModelChange)="updateParents()">
                <label class="form-check-label" [attr.for]="'doImport' + p.parentId">
                    {{p.parentName}}
                </label>
            </div>
        </div>
        <div class="row gx-3 mb-2" *ngIf="submitAttempt && connString && !hasParent">
            <input type="hidden" class="form-control is-invalid" />
            <div class="invalid-feedback">
                <i class="fas fa-exclamation-circle"></i> Select at least one Parent Account.
            </div>
        </div>
        <div class="row gx-3">
            <div class="col-md-4 mb-3">
                <label for="isBilling" class="form-label">Update Source Environment</label>
                <div class="form-check checkbox-slider--b-flat checkbox-slider-md">
                    <label class="m-0">
                        <input type="checkbox" id="doSourceUpdate" name="doSourceUpdate" [(ngModel)]="doSourceUpdate"><span class="user-toggle">{{doSourceUpdate ? 'Yes' : 'No'}}</span>
                    </label>
                </div>
            </div>
            <div class="col-md-4 mb-3">
                <label for="isBilling" class="form-label">Add .disabled to New Users</label>
                <div class="form-check checkbox-slider--b-flat checkbox-slider-md">
                    <label class="m-0">
                        <input type="checkbox" id="disableUsers" name="disableUsers" [(ngModel)]="disableUsers"><span class="user-toggle">{{disableUsers ? 'Yes' : 'No'}}</span>
                    </label>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-black btn-round btn-lg" (click)="dismiss()"><i class="far fa-times"></i> Cancel</button>
        <button type="submit" class="btn btn-secondary btn-round btn-lg" (click)="import()"><i class="far fa-file-import"></i> Import</button>
    </div>
</form>